module.exports = __webpack_public_path__ + "static/media/cq_tabella.fc8e6c37.svg";